import { render, staticRenderFns } from "./UserTransactionUnseal.vue?vue&type=template&id=4774143a&scoped=true&"
import script from "./UserTransactionUnseal.vue?vue&type=script&lang=js&"
export * from "./UserTransactionUnseal.vue?vue&type=script&lang=js&"
import style0 from "./UserTransactionUnseal.vue?vue&type=style&index=0&id=4774143a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4774143a",
  null
  
)

export default component.exports